export function legacyRevisionTakeawaysTarget(search = "") {
  const params = new URLSearchParams(search);
  params.set("view", params.has("resource") ? "catalogue" : "imports");
  return `/admin/resources?${params.toString()}`;
}
